'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = HorizontalRule;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorizontalRule(_ref) {
	var moduleClass = _ref.moduleClass,
	    addClass = _ref.addClass;

	return _react2.default.createElement('hr', {
		className: 'type-horizontal_rule ' + moduleClass + ' ' + addClass
	});
} /*
  	 {
  		 "type": "horizontal_rule",
  		 "addClass": "some-class-name"
  	 }
  
  	 For displaying an <hr> tag.
  */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/HorizontalRule/HorizontalRule.jsx
// module id = 1166
// module chunks = 0